// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__visHQ","label":"styles_label__5b_NX","caption":"styles_caption__kBYxW","description":"styles_description__AHMAi","content":"styles_content__0B1O8"};